import { getStateDisplayName } from 'store/utils/shipmentUtils';

/**
 * How a facility is written on screen.
 *
 * Several sites are called things like "PerfectRx" and "PerfectionRx", and a name on its own does
 * not tell them apart at a glance — which is how a row from the wrong facility reads as one from
 * the right one. The state is what makes them distinguishable, so it travels with the name.
 *
 * Two forms, because the space differs: pickers, headings and dialogs have room for the state's
 * full name, while a table cell or a column header does not and takes the two-letter code.
 */

/** "PerfectRx Plano (Texas)" — pickers, headings and dialogs. */
export const formatFacilityWithState = (name, state) => {
  if (!name) return '';
  return state ? `${name} (${getStateDisplayName(state)})` : name;
};

/** "PerfectRx Plano (TX)" — table cells and column headers, where the full name will not fit. */
export const formatFacilityWithStateCode = (name, state) => {
  if (!name) return '';
  return state ? `${name} (${state})` : name;
};

/**
 * The same, for the places that hold a facility id rather than the record — the alert widgets and
 * the transaction ledger name a facility by id and look the rest up.
 */
export const buildFacilityLabelLookup = (facilities = [], { short = true } = {}) => {
  const format = short ? formatFacilityWithStateCode : formatFacilityWithState;

  return facilities.reduce(
    (labels, facility) => ({
      ...labels,
      [facility.fulfillingPharmacyId]: format(facility.name, facility.state),
    }),
    {}
  );
};
